export const extractRows = (res) => {
  if (Array.isArray(res)) return res;
  if (Array.isArray(res?.result?.data?.content)) return res.result.data.content;
  if (Array.isArray(res?.result?.data)) return res.result.data;
  if (Array.isArray(res?.result)) return res.result;
  if (Array.isArray(res?.data)) return res.data;
  return [];
};

export const toOptions = (rows, idKeys, labelKeys) =>
  rows
    .map((row) => {
      const id = idKeys.map((key) => row[key]).find((val) => val != null);
      const label = labelKeys.map((key) => row[key]).find((val) => val != null);
      return id != null && label != null ? { id, label } : null;
    })
    .filter(Boolean);

export const withCurrentOption = (options, current, idKey) => {
  if (current?.[idKey] == null || current[idKey] === '') return options;
  const exists = options.some((option) => String(option[idKey]) === String(current[idKey]));
  return exists ? options : [current, ...options];
};
